import { TranslationKeyMap } from '../landing.i18n';
import { ColumnId } from '../model/column-id.model';

export const tableColumns: Array<{
    id: ColumnId;
    label: string;
    classSuffix: string;
}> = [
    {
        id: ColumnId.EVENT_DATE,
        label: TranslationKeyMap._9999_EVENT_DATE,
        classSuffix: 'event-date',
    },
    {
        id: ColumnId.EVALUATION_ID,
        label: TranslationKeyMap._10029_EVALUATION_ID,
        classSuffix: 'evaluation-id',
    },
    {
        id: ColumnId.USER_NAME,
        label: TranslationKeyMap._102_USER_NAME,
        classSuffix: 'user-name',
    },
    {
        id: ColumnId.MANAGER,
        label: TranslationKeyMap._48_MANAGER,
        classSuffix: 'manager',
    },
    {
        id: ColumnId.EVALUATOR,
        label: TranslationKeyMap._10030_EVALUATOR,
        classSuffix: 'evaluator',
    },
    {
        id: ColumnId.EVALUATION_NAME,
        label: TranslationKeyMap._9998_EVALUATION_NAME,
        classSuffix: 'evaluation-name',
    },
    {
        id: ColumnId.SCORE,
        label: TranslationKeyMap._752_SCORE,
        classSuffix: 'score',
    },
    {
        id: ColumnId.STATUS,
        label: TranslationKeyMap._127_STATUS,
        classSuffix: 'status',
    },
    {
        id: ColumnId.SELECT,
        label: null,
        classSuffix: 'select',
    },
];
